import React from 'react'
import { Text, H5 } from 'library/atoms/Typography'

export interface SummaryProps {
  topText: string | React.ComponentType
  bottomText: string | React.ComponentType
}

const Summary = ({
  topText: TopText,
  bottomText: BottomText
}: SummaryProps): JSX.Element => {
  return (
    <div>
      <H5 mt="inherit">
        {typeof TopText === 'string' ? TopText : <TopText />}
      </H5>
      {typeof BottomText === 'string' ? (
        <Text size="xs" role="document">
          {BottomText}
        </Text>
      ) : (
        <Text as="div" size="xs" role="document">
          <BottomText />
        </Text>
      )}
    </div>
  )
}

export default Summary
